import type React from "react";

import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import { EmailSignup } from "./views/EmailSignup";

export const SignupRoutes: React.FC = () => {
  const { search } = useLocation();

  return (
    <Routes>
      <Route path="billing_admin/email" element={<EmailSignup />} />
      <Route path="clinic_partner/email" element={<EmailSignup />} />
      <Route path="doctor/email" element={<EmailSignup />} />
      <Route path="physician/email" element={<EmailSignup />} />
      <Route
        path="therapist/bankid"
        element={
          <Navigate
            to={{
              pathname: "/login/bankid",
              search,
            }}
          />
        }
      />
      <Route path="therapist/email" element={<EmailSignup />} />
    </Routes>
  );
};
